__webpack_require__.p = "https://vimp.foodconceptsplc.com/";